import { ReactNode } from "react";
import { Banner } from "@newsela/angelou";
import { bannerCss, panelContentCss } from "./CitationGeneratorBodyPanel.style";

interface CitationGeneratorBodyPanelProps {
  citation: ReactNode;
  showBanner: boolean;
  setShowBanner: (showBanner: boolean) => void;
}

const CitationGeneratorBodyPanel = ({
  citation,
  showBanner,
  setShowBanner,
}: CitationGeneratorBodyPanelProps) => {
  return (
    <>
      {showBanner && (
        <Banner
          bannerType={Banner.types.alert}
          body="Some important information is missing, please edit them manually."
          isCenter
          isDismissible
          __cssFor={{ root: bannerCss }}
          onClose={() => setShowBanner(false)}
        />
      )}
      <p css={panelContentCss}>{citation}</p>
    </>
  );
};

export default CitationGeneratorBodyPanel;
